import { render } from "./ProductosViews.vue?vue&type=template&id=707d10e7&scoped=true"
import script from "./ProductosViews.vue?vue&type=script&lang=js"
export * from "./ProductosViews.vue?vue&type=script&lang=js"

import "./ProductosViews.vue?vue&type=style&index=0&id=707d10e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707d10e7"]])

export default __exports__